import {
  CampaignPerformanceAudiencesResponse,
  PerformanceAudienceFilterOption,
} from '@/services/endpoints/performanceAudience';

const extractAudienceItems = (response: CampaignPerformanceAudiencesResponse | undefined) => {
  if (!response) {
    return [];
  }

  if (Array.isArray(response)) {
    return response;
  }

  return response.audiences ?? [];
};

export const mapCampaignPerformanceAudiencesToFilterOptions = (
  response: CampaignPerformanceAudiencesResponse | undefined,
  fallback: PerformanceAudienceFilterOption[]
): PerformanceAudienceFilterOption[] => {
  const mapped = extractAudienceItems(response)
    .map((item): PerformanceAudienceFilterOption | null => {
      const id = item.id ?? item.audienceId;
      const name = item.name ?? item.label ?? item.value;

      if (!id || !name) {
        return null;
      }

      return {
        id: String(id),
        value: String(name),
      };
    })
    .filter((item): item is PerformanceAudienceFilterOption => item !== null);

  return mapped.length > 0 ? mapped : fallback;
};
